import { get } from "../lib/axios";
import { Expertise } from "../types/expertise";

export function getAllExpertise() {
  return get<Expertise[]>("/expertise");
}
